import React from 'react'
import { CustomFormProps } from 'types/common'
import LogisticSelectInput from 'ui-shared/CustomInputs/LogisticSelectInput'
import OptionedProductForm from 'ui-shared/Forms/OptionedProductForm'
import FoodFacetSection from 'ui-shared/Facets/FacetFormSections/FoodFacetSection'
import LinkedRulesPanel from 'ui-shared/LinkedRulesPanel'
import { yupResolver } from '@hookform/resolvers/yup'
import { foodVS } from 'services/validations/catalog/food'

const FoodForm: React.FC<CustomFormProps> = (props) => (
  <OptionedProductForm
    {...props}
    resolver={yupResolver(foodVS)}
    facetFields={<FoodFacetSection />}
    slotBeforeHighlights={<LogisticSelectInput />}
    upsellingEntity="foodsupselling"
  >
    <LinkedRulesPanel {...props} />
  </OptionedProductForm>
)

export default FoodForm
